import React, { useContext, useState } from 'react'
import DefaultLayout from '../layouts/default'
import { Button, Container, Divider, Heading, HStack, Input, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Text, Textarea, useToast, VStack } from '@chakra-ui/react';
import { GlobalContext } from '../component/GlobalContext';
import { apiBaseURL } from '../config';

const CreateApp = ({ props }) => {

	const toast = useToast();
	const { userInfo } = useContext(GlobalContext);

	const [appData, setAppData] = useState({
		appName: "",
		poolSize: 1,
		initialCommands: ""
	});

	const [appName, setAppName] = useState(undefined);
	const [appId, setAppId] = useState(undefined);

	const handleDeleteApp = () => {
		if (appName !== undefined) {
			fetch(`${apiBaseURL}/remove_application`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "Authorization": `Bearer ${userInfo.token}` },
				body: JSON.stringify({
					name: appName,
					token: userInfo.token,
				}),
			})
				.then((res) => {
					res.json().then((data) => {
						if (!data.error) {
							setAppName(undefined);
							setAppId(undefined);
							toast({
								title: "Success",
								description: `Application ${appName} deleted successfully`,
								status: "success",
								duration: 3000,
								isClosable: true,
								position: "bottom-right",
							})
						}
						else {
							toast({
								title: "Error",
								description: data.msg,
								status: "error",
								duration: 3000,
								isClosable: true,
								position: "bottom-right",
							});
						}
					})
				})
				.catch((err) => {
					toast({
						title: "Error",
						description: err.toString(),
						status: "error",
						duration: 3000,
						isClosable: true,
						position: "bottom-right",
					});
				});
		}
	}

	const handleCreateApp = () => {

		if (appData.appName !== "") {
			const commands = appData.initialCommands.split("\n").filter((c) => c.trim() !== '');
			fetch(`${apiBaseURL}/create_application`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "Authorization": `Bearer ${userInfo.token}` },
				body: JSON.stringify({
					name: appData.appName,
					commands: commands,
					pool_size: appData.poolSize,
					token: userInfo.token,
				}),
			})
				.then((res) => {
					res.json().then((data) => {
						if (!data.error) {
							setAppName(appData.appName)
							setAppId(data.application_id)
							console.log(data.application_id);
							setAppData({
								appName: "",
								poolSize: 1,
								initialCommands: ""
							})
							toast({
								title: "Success",
								description: `Application ${appData.appName} created successfully`,
								status: "success",
								duration: 3000,
								isClosable: true,
								position: "bottom-right",
							})
						}
						else {
							toast({
								title: "Error",
								description: data.msg,
								status: "error",
								duration: 3000,
								isClosable: true,
								position: "bottom-right",
							});
						}
					})
				})
				.catch((err) => {
					toast({
						title: "Error",
						description: err.toString(),
						status: "error",
						duration: 3000,
						isClosable: true,
						position: "bottom-right",
					});
				});
		}
		else {
			toast({
				title: "Error",
				description: "Insert an application name",
				status: "error",
				duration: 3000,
				isClosable: true,
				position: "bottom-right",
			});
		}
	}


	const handleChangeAppData = (e) => {
		setAppData({
			...appData,
			[e.target.name]: e.target.value
		})
	}

	const handleChangePoolSize = (value) => {
		setAppData({
			...appData,
			poolSize: parseInt(value)
		})
	}

	return (
		<DefaultLayout>
			<Container>
				<VStack align="start" spacing={4} w="100%">
					<Heading as="h1">Create application</Heading>
					<Input
						name="appName"
						placeholder="Application name"
						onChange={handleChangeAppData}
						value={appData.appName}
					/>
					<Text mb={0} mt={2} >Initial commands</Text>
					<Textarea
						name='initialCommands'
						height={"200px"}
						placeholder="Initial commands"
						value={appData.initialCommands}
						onChange={handleChangeAppData}
					/>
					<HStack alignItems={"center"}>
						<Text
							mb={0}
							w={"80px"}
						>
							Pool Size
						</Text>
						<NumberInput
							onChange={handleChangePoolSize}
							defaultValue={1}
							value={appData.poolSize}
							min={1}
							max={20}
							w="80px"
						>
							<NumberInputField />
							<NumberInputStepper>
								<NumberIncrementStepper />
								<NumberDecrementStepper />
							</NumberInputStepper>
						</NumberInput>
					</HStack>
					<Button
						onClick={handleCreateApp}
						alignSelf={"flex-end"}
						variant="outline"
						{...props}
					>
						Create App
					</Button>
				</VStack>
				<Divider borderColor={"black"} />
				{appName &&
					<HStack
						justifyContent={"space-between"}
					>
						<VStack alignItems={"flex-start"}>
							<Text>Application name: {appName}</Text>
							<Text>Application id: {appId}</Text>
						</VStack>
						<Button
							onClick={handleDeleteApp}
							variant="outline"
							{...props}
						>
							Remove App
						</Button>
					</HStack>

				}
			</Container>
		</DefaultLayout>
	)
}
export default CreateApp;